import { render } from "./BankHolidayCountdown.vue?vue&type=template&id=e6376502"
import script from "./BankHolidayCountdown.vue?vue&type=script&lang=js"
export * from "./BankHolidayCountdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__